import BaseNode from './BaseNode';
import LoopIcon from '@mui/icons-material/Loop';
import { colors } from '../../styles';

const LoopNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Repetição" accent={colors.status.pending} icon={<LoopIcon />} />
);

export default LoopNode;
